import { DataTableCell, Table, TableBody, ExposePage, SubTitle } from "@onpreo/pdf-components";

const RoomTableDataClean = props => {
    return (
        <ExposePage {...props}>
            <SubTitle>Flächenaufteilung</SubTitle>
            <Table data={props.roomTableDataClean}>
                <TableBody renderTopBorder={false}>
                    <DataTableCell weighting={0.75} getContent={r => r.key} />
                    <DataTableCell weighting={0.25} getContent={r => r.val} />
                </TableBody>
            </Table>
        </ExposePage>
    );
};

export default RoomTableDataClean;
